module.exports = __webpack_public_path__ + "img/bubble.e30709de.png";